module.exports = __webpack_public_path__ + "static/media/bgAirFreight.a879fb5e.jpg";